export default __webpack_public_path__ + "static/media/Misery.868521c4.jpg";